import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface IChevronUpIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const ChevronUpIcon = ({
  width = styleConfigs.dimensions.width20,
  height = styleConfigs.dimensions.height20,
  color = COLORS.ebonyClay,
  ...props
}: IChevronUpIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0004 5.8995C10.1951 5.8991 10.3838 5.9669 10.5337 6.0912L15.5337 10.2578C15.8881 10.5524 15.9366 11.0784 15.6421 11.4328C15.3475 11.7872 14.8214 11.8357 14.4671 11.5412L10.0004 7.8078L5.53374 11.4078C5.36164 11.5476 5.14085 11.613 4.92025 11.5896C4.69964 11.5661 4.49751 11.4557 4.35874 11.2828C4.20436 11.1096 4.12927 10.8799 4.15145 10.649L9.15145 6.64218C9.30566 6.53744 9.49057 6.48759 9.67645 6.50049L10.0004 5.8995Z"
      fill={color}
    />
  </svg>
);

export default ChevronUpIcon;
